import { useMutation } from "react-query";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { internalApi } from "@/react/helpers/urlHelpers";
import type { Conversation } from "../components/common/ConversationItem";
import type { VirtualConversationType } from "../types/VirtualMessage";

interface UseCreateChatProps {
  onError: (error: unknown) => void;
  onSuccess: (conversation: Conversation) => void;
}

interface CreateChatParams {
  text?: string;
  virtual_conversation_type?: VirtualConversationType | null;
}

export const useCreateChat = ({ onSuccess, onError }: UseCreateChatProps) =>
  useMutation<{ conversation: Conversation }, unknown, CreateChatParams>({
    mutationFn: async ({ text, virtual_conversation_type }: CreateChatParams) =>
      reactQueryPost(internalApi.helpWidget.createChat(), {
        text,
        virtual_conversation_type,
      }),
    onSuccess: data => {
      onSuccess(data.conversation);
    },
    onError,
  });
